import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { translations } from './translations';

console.log('🟢 LanguageContext loaded');

type Language = 'en' | 'ja' | 'es' | 'fr' | 'de' | 'it' | 'pt' | 'ko' | 'zh';

type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

type LanguageProviderProps = {
  children: ReactNode;
};

export function LanguageProvider({ children }: LanguageProviderProps) {
  console.log('🟢 LanguageProvider initializing');
  const [language, setLanguageState] = useState<Language>(() => {
    console.log('🟢 Reading language from localStorage');
    const saved = localStorage.getItem('mapsound-language') as Language;
    console.log('🟢 Saved language:', saved);
    const validLanguages: Language[] = ['en', 'ja', 'es', 'fr', 'de', 'it', 'pt', 'ko', 'zh'];
    return validLanguages.includes(saved) ? saved : 'en';
  });

  useEffect(() => {
    localStorage.setItem('mapsound-language', language);
  }, [language]);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
  };

  const t = (key: string): string => {
    const keys = key.split('.');
    let value: any = translations[language];

    for (const k of keys) {
      value = value?.[k];
    }

    return typeof value === 'string' ? value : key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
